/* eslint-disable sonarjs/cognitive-complexity */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { message as toaster } from 'antd';
import { Box, Image, Text, Flex } from 'atoms';
import goBack from 'assets/go-back.svg';
import RefreshIcon from 'assets/refresh.svg';
import { setShowLogout, setinvoiceDate, TODAY } from 'store/appSlice';
import { ClearConfirmation } from 'components/pages/collection';
// import { useQueryParams } from 'hooks';
import { AR } from 'utils/constants';
import { setselectedSalesMan } from 'store/userSlice';
// import { getSalesInvoicesList } from 'store/salesmanSlice';
import MakeAllBillBack from './MakeAllBillBack';

export default function SalesHeaderCollection() {
	const [isAnyPending, setIsAnyPending] = useState(false);

	const [showAllBillBackModal, setShowAllBillBackModal] = useState(false);
	const [showGoBackConfirmation, setShowGoBackConfirmation] = useState(false);
	const { me = {}, selectedSalesMan = {} } = useSelector((state) => state.user);
	const { invoiceDate } = useSelector((state) => state.app);

	const {
		SalesInvoices = [],
		isInvoiceOpen = false,
		isAccordionOpen,
		store_data,
	} = useSelector((state) => state.salesman);
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	// const { salesmanId = undefined } = useQueryParams();
	const [default_status, setDefaultStatus] = useState(
		'Are you sure want to go back to collections,this will clear the entered values'
	);

	useEffect(() => {
		// denomination
		if (
			Array.isArray(store_data?.invoices) &&
			store_data?.invoices.some((item) => item?.action === 'SUBMIT')
		) {
			setDefaultStatus('Are you sure want to go back to collection');
		}
		if (store_data?.payments.length > 0) {
			setDefaultStatus('Are you sure want to go back to collection');
		}
		if (SalesInvoices?.some((item) => item?.status === 'Pending')) {
			setIsAnyPending(true);
		}
	}, [SalesInvoices, location, store_data?.invoices, store_data?.payments.length]);

	function goToSalesMenListPage() {
		dispatch(setselectedSalesMan({}));
		setTimeout(() => {
			history.push('sales-men');
		}, 1000);
	}

	const showModal = () => {
		if (isInvoiceOpen) {
			toaster.error('Please close the invoice');
		} else if (me?.type === AR) {
			goToSalesMenListPage();
		} else if (isAnyPending) {
			/**
			 * In Additional Resource login, if they click back it will go back to sales men list page
			 */
			setShowAllBillBackModal(true);
		} else {
			// setShowDetailView(false);
			dispatch(setShowLogout(true));
		}
	};

	const checkAccordionStatus = () => {
		/**
		 * If selected date is not today date means, on clicking on logout first the date will be changed to today date
		 */

		if (location?.pathname === '/outlet') {
			setShowGoBackConfirmation(true);
		} else if (me?.type === AR) {
			goToSalesMenListPage();
		} else if (invoiceDate !== TODAY) {
			dispatch(setinvoiceDate(TODAY));
		} else if (!isAccordionOpen && isInvoiceOpen && isAnyPending) {
			/**
			 * If any invoice is still in pending state, before logout it will ask to force bill back
			 */
			setShowAllBillBackModal(true);
		} else {
			showModal();
		}
	};

	function getLatestInvoices() {
		// dispatch(getSalesInvoicesList(salesmanId));
		window.location.reload();
	}

	function handleRedirect() {
		if (me.type === AR) {
			history.push(`/invoices-collection?salesmanId=${selectedSalesMan?.id}`);
		} else {
			history.push('/invoices-collection');
		}
	}

	return (
		<>
			<MakeAllBillBack
				visible={showAllBillBackModal}
				hide={() => setShowAllBillBackModal(false)}
			/>
			<Flex
				justifyContent="space-around"
				alignItems="center"
				height="44px"
				bg="#0168D0"
				color="#fff"
			>
				<Box cursor="pointer" onClick={checkAccordionStatus}>
					<Image src={goBack} alt="Logout" height={12} width={12} />
				</Box>
				<Text fontSize="12px">Store Page</Text>
				<Flex justifyContent="flex-end" alignItems="center" width="60%">
					<Box
						cursor="pointer"
						mx="12px"
						onClick={getLatestInvoices}
						pr={location?.pathname === '/outlet' ? '60%' : '0'}
					>
						<Image src={RefreshIcon} alt="RefreshIcon" height={24} width={24} />
					</Box>
				</Flex>
			</Flex>
			<ClearConfirmation
				visible={showGoBackConfirmation}
				onClose={() => setShowGoBackConfirmation(false)}
				onClear={handleRedirect}
				infoText={default_status}
				yesText="Yes"
			/>
		</>
	);
}
